<template>
  <div class="body-box">
    <el-row class="plan">
      <el-col :span="24">
        <el-button @click="dialogVisible = true">修改比赛</el-button>
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 70px)'" :data="list" class="button-box">
      <el-table-column type="index" width="100"/>
      <el-table-column label="名字" prop="name"/>
      <el-table-column label="缩略图">
        <template slot-scope="scope">
          <icon-img :icon="scope.row.thumbnail"></icon-img>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="修改比赛" :visible.sync="dialogVisible" width="80%">
      <el-form label-width="80px">
        <el-row>
          <el-col :span="6" v-for="(item, index) in gameContent.module" :key="index">
            <el-form-item label="名称">
              <el-input v-model="item.name"></el-input>
            </el-form-item>

            <el-form-item label="缩略图">
              <thumbnail v-model="item.thumbnail"></thumbnail>
            </el-form-item>
          </el-col>

          <!--<el-col :span="24">
            <el-form-item label="轮播图">
              <thumbnail-list v-model="gameContent.carousel"></thumbnail-list>
            </el-form-item>
          </el-col>-->


        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="subGame">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getTemplatesByKey,postTemplatesById } from '@/api/temp/temp'
import ThumbnailList from '@/components/common/thumbnailList/thumbnailList'
import Thumbnail from '@/components/common/thumbnail/thumbnails'
import IconImg from '@/components/common/pictureImg/index'

export default {
  components: { IconImg, Thumbnail, ThumbnailList },
  data() {
    return {
      gameContent: {},
      gameForm: {},
      list: [],
      dialogVisible: false
    }
  },
  created() {
    this.getTemplatesByKeyList()
  },
  methods: {
    getTemplatesByKeyList() {
      getTemplatesByKey('RACE').then(res => {
        let obj = res.data.content
        this.gameContent = JSON.parse(obj)
        this.list = JSON.parse(obj).module
        this.gameForm = res.data
      })
    },

    subGame() {
      this.gameForm.content = JSON.stringify(this.gameContent)
      postTemplatesById(this.gameForm, this.gameForm.id).then(res => {
        if (res.code === '0') {
          this.dialogVisible = false
          this.$message.success('修改成功');
          this.$router.go(0)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
